import { useCallback } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useProfile } from "@/hooks/useProfile";
import { updateMyProfile } from "@/features/identity/api/profileApi";

export function useIdentity() {
  const { user } = useAuth();
  const { profile, setProfile } = useProfile();

  const saveProfile = useCallback(
    async (patch) => {
      const updated = await updateMyProfile(patch);
      setProfile(updated);
      return updated;
    },
    [setProfile],
  );

  return { user, profile, saveProfile };
}
